module.exports = __webpack_public_path__ + "static/media/05.101.8ea6af56.webp";